export default {"src":"/_next/static/media/icon-sanctuary-forge-apostle.2fa17dda.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};